import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IClass, IClasses } from '../interfaces/class';

@Injectable({
  providedIn: 'root',
})
export class ClassService {
  constructor(private httpClient: HttpClient) {}

  getClasses(url: string, filters: any): Observable<IClasses> {
    return this.httpClient.get<IClasses>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IClasses>;
  }

  getClassById(url: string): Observable<IClass> {
    return this.httpClient.get<IClass>(url, { headers: { accept: '*/*' } }) as Observable<IClass>;
  }

  editClass(url: string, classForm: any): Observable<IClass> {
    return this.httpClient.patch<IClass>(url, classForm, {
      headers: { accept: '*/*' },
    }) as Observable<IClass>;
  }

  createClass(url: string, classForm: any): Observable<IClass> {
    return this.httpClient.post<IClass>(url, classForm, {
      headers: { accept: '*/*' },
    }) as Observable<IClass>;
  }
}
